import { conversation } from 'ducks/entities/schema'

export const conversationsGraphQlResponseSchema = {
  conversations: { nodes: [conversation] },
}
